import React, { useEffect, useState } from "react";
import { PickersDay, PickersDayProps } from "@mui/x-date-pickers/PickersDay";
import { Moment } from "moment";
import { DateCalendar, DateCalendarProps } from "@mui/x-date-pickers/DateCalendar";
import Badge from "@mui/material/Badge";
import { Box, Tooltip, Typography } from "@mui/material";
import Api from "../../openapi";
import moment from "moment";
import {
  ChooseIcon,
  DeliveredIcon,
  LockIcon,
  OffIcon,
  PrepareIcon,
  Restaurant2Icon,
  RestaurantIcon,
  SelectedDisabledIcon,
  SelectedIcon,
} from "../../assets/icons";
import { CommonProps } from "@mui/material/OverridableComponent";
import { checkEmpty, checkIf, defaultFormat } from "../../utils";
import {
  DeliveryAddressCalendarResponse,
  DeliveryAddressCalendarResponseStatusEnum,
  MealTypeResponse,
  MenuBriefResponse,
} from "../../openapi/client";
import theme from "../../theme";
import { MonthlyCache } from "../../openapi/interfaces";
import { GraySpinner, MainSpinner } from "../Spinner";
import { DateSelection } from "../../pages/UserDetail";

export default function CustomDay(
  props: PickersDayProps<Moment> & {
    daysinfo?: DateSelection[];
  }
) {
  const { day, outsideCurrentMonth, daysinfo, today, selected, classes, ...other } = props;
  const past = day.isBefore(moment().startOf("day"));
  const selectedPauseDay = daysinfo?.find(
    (i) => i.startDate === day.format(defaultFormat) && i.endDate === day.format(defaultFormat)
  );

  const className = `${selected ? "selected" : ""} ${today ? "today" : ""} ${past ? "past" : ""} ${
    selectedPauseDay ? "selectedPauseDay" : ""
  }`;

  // console.log(props.deliveryInfo);
  // console.log("props.activeAddress", props.activeAddress);
  // console.log("days info", daysinfo);
  // console.log("classes", classes);
  // console.log("day", day);
  // console.log("day of month", day.format("D"));
  // console.log("selectedPlan", selectedPlan);
  // console.log("props.daysInfo", props.daysinfo);
  //   const isSelected = !props.outsideCurrentMonth && highlightedDays.indexOf(props.day.date()) >= 0;
  //   const status = props.daysinfo?.find((info: any) => info.date === props.day.format(defaultFormat))
  //     ?.status as PlanDayResponseStatusEnum;

  const handleDaySelect = (day: Moment) => {
    props.onDaySelect(day);
  };

  //   const { icon, className, explanation } = getStatusInfo(status);

  return (
    <PickersDay
      key={props.day.format(defaultFormat)}
      {...other}
      disabled={other.disabled}
      classes={classes}
      className={className}
      outsideCurrentMonth={outsideCurrentMonth}
      day={day}
      onDaySelect={handleDaySelect}
      sx={{
        "&.today > span.MuiTypography-root": { border: "2px solid #FF8F0B" },
        "&.selected": { backgroundColor: "rgba(255, 143, 11, 0.08)" },
        // "&.past": { opacity: "0.25" },
        "&.selectedPauseDay": { backgroundColor: "primary.main", color: "white" },
      }}
    />
  );
  {
    /* <Typography sx={{ fontSize: "12px", color: "#000", lineHeight: "normal" }} component={"span"}>
        {day.format("D")}
      </Typography> */
    /* </PickersDay> */
  }
}
